import { Injectable } from '@angular/core';
import { UserService } from '@shared/services/user.service';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject, Subscription, interval } from 'rxjs';
import { ModalController, Platform, ToastController } from '@ionic/angular';
import { HttpClient } from '@angular/common/http';
import { Preferences } from '@capacitor/preferences';
import { LoginPage } from '../pages/login/login.page';
import { PicturesPage } from '../pages/pictures/pictures.page';
import { Directory, Filesystem } from '@capacitor/filesystem';
import { Router } from '@angular/router';
import { EventService } from '@shared/services/event.service';
import { UtilService } from '@shared/utils/util';

@Injectable({
  providedIn: 'root'
})
export class MatchService {
  private matchSubject = new Subject<number>();
  public userData : any;
  public souls: any = [];
  private refreshSubs : Subscription = new Subscription();
  public chattingToSoul: string| any = null;

  public haveMatchWithMessages: boolean = false;
  public haveMatch: boolean = false;

  constructor(public userService: UserService,
              private translate: TranslateService,
              private platform: Platform, 
              private toastCtrl: ToastController,
              private util: UtilService,
              private router: Router,
              public http: HttpClient,
              public modalCtrl: ModalController,
              private eventService: EventService) {


    console.log('Hello MatchServiceProvider');
    this.ensureLoggedInAndLoad();

    this.startRefresh(false);

    platform.ready().then(() => {

      Preferences.get({key:'MATCHES'}).then((val) => {

        val = val.value ? JSON.parse(val.value) : null;

        if(val === null){
          // do nothing. Matches will stay empty unless fetched from server.
        } else{
          this.souls = val;
          this.haveMatch = this.souls.length > 0;
          this.haveMatchWithMessages = this.souls.some((soul: any) => soul.lastMessage != null);
        }
      })
    })
  }

  public restartRefresh(){
    this.stopRefresh();
    this.ensureLoggedInAndLoad();
    this.startRefresh(false);
  }

  public stopRefresh(){
    this.refreshSubs.unsubscribe();
    this.refreshSubs = interval(1000 * 60 * 30).subscribe(x => { // subscribe the 30 minutes
      this.ensureLoggedInAndCheckForNew();
    });

  }

  public startRefresh(refreshNow: boolean){
    if(refreshNow){
      this.ensureLoggedInAndCheckForNew();
    }
    this.refreshSubs.unsubscribe();// unsubscribe the 30 minutes one
    console.log('Will subscribe for 10 seconds...');
    this.refreshSubs = interval(1000 * 10).subscribe(x => {
      console.log('Will call ensureLoggedInAndCheckForNew...');
      this.ensureLoggedInAndCheckForNew();
    });
  }


  public getUpdates() : Subject<number> {
    return this.matchSubject;
  }
  public ensureLoggedInAndCheckForNew(){

    try {
      if(UserService.loggedOut){
        console.log('SoulServiceProvider.loggedOut. Returning within ensureLoggedInAndCheckForNew');
        return;
      }
  
      Preferences.get({key:'USER_DATA'}).then((val) => {
        val = val.value ? JSON.parse(val.value) : null;
        if(val === null){
          // No data for now
          this.souls = [];// just in case logged in with a different user
          return;
        }

        this.userData = val;

        let since: number = 0;
        if(this.souls.length > 0){
          since = this.souls[0].relevantDate;
        }

        var theObs : Observable<any>;
        if(this.userData?._id.$oid != undefined){
          theObs =  this.userService.getNewMessagesMatches(this.userData?._id.$oid, since, this.userData);
          if(theObs != null){
            theObs.subscribe(async data => {
              console.log('getNewMessagesMatches subscribe entered');
              console.log('data = ' + JSON.stringify(data));
  
              if(data == '{not ok}'){
                await this.userService.clearLocalStorage();
                //this.appCtrl.getRootNav().setRoot();
  
                
                this.stopRefresh();
                this.router.navigateByUrl('/login');
  
                return;
  
              }else{
  
                if(data != null && data > 0){
                  this.loadMatches(true);
                  //Notify to update tab badge
                }
              }
  
            },
            err => {
              this.util.showToastUnableToConnect(this.toastCtrl);
              console.log('Error: ' + JSON.stringify(err));
            });
          }
        }


      });

        
    } catch (error) {
      console.log('Error on ensureLoggedInAndCheckForNew() on match-service:')
      console.log(error)
      console.error(error);
      
    }



  }

  public ensureLoggedInAndLoad(){

    if(!UserService.loggedOut){
      Preferences.get({ key: 'USER_DATA' }).then((val:any) => {
        val = val.value ? JSON.parse(val.value) : null;
  
        if(val === null){
          // Nothing for now
          return;
        }
        console.log('ensureLoggedInAndLoad userdata!=null');

        this.userData = val;
        this.loadMatches(false);
      })
  
    }

  }

  loadMatches(notify: boolean){
    try {
      // Check if user is loggedOut
      if(UserService.loggedOut){
        console.log('SoulServiceProvider.loggedOut. Returning within loadMatches');
        return;
      }

      // Load Matches from Server
      var theObs : Observable<any>;
      theObs =  this.userService.getMatches(this.userData);

      //Treat the returned data
      if(theObs != null){
        theObs.subscribe(async data => {
          console.log('getMatches subscribe entered');
          if(data != '{not ok}'){
            data = JSON.parse(data);
          
            this.loadScreen(data);
          }else{
            await this.userService.clearLocalStorage();
            this.stopRefresh();
            this.router.navigateByUrl('/login');
            return;
          }

        },
        err => {
          this.loadScreen(this.souls);
          console.log('Error: ' + JSON.stringify(err));
        })
      }else{
        console.log('Matches are empty');
        // matches are empty. Show something with a sad face
      }
    } catch (error) {
      console.log('Error on loadMatches() on match-service:')
      console.log(error)
      console.error(error);

    }

  }

  loadScreen(data: any){
    try {
      if(data != null){
          
        let newSouls = [];
        let newOnes: number = 0;
  
        for (let i = data.length-1; i > -1; i--) {
          let aMatch = data[i];
  
          // Setup this as default
          aMatch.firstPic = PicturesPage.noPicture;
          this.useURLforImage(aMatch);
  
          if(aMatch.lastMessage==null){
            aMatch.theMessage = this.translate.instant('sayHi') + ' :)';
            aMatch.newBadge = !aMatch.read;
  
            if(aMatch.newBadge){
              //register match event
              // TODO
              // matches.read is set to true when user goes to Chat-List tab or only when it opens the Chat
              // To discus, in case user has to open the Chat: matches.analyticsSent = true. If matches.analyticsSent, send and set analyticsSent
              // Just save a list of SoulId for matches already sent to analytics in the client database
              // this.analytics.registerEvent(AnalyticsProvider.matchEvent);
              console.log("! Analytics 'match_chat_list' event sent !");
  
              aMatch.newBadge = false;
              console.log("aMatch.newBadge status: "+ aMatch.newBadge);
  
            }
       
          } else{
            aMatch.theMessage = (aMatch.lastMessage.message != undefined && aMatch.lastMessage.message != null)?aMatch.lastMessage.message:'';
            if(!aMatch.lastMessage.sent && !aMatch.lastMessage.read){
              aMatch.newBadge = true;
            }
            let msg = aMatch.theMessage
            if(typeof msg == "object" || (aMatch.theMessage.trim().startsWith('{') && aMatch.theMessage.trim().endsWith('}'))){
              try {
                let audioMsg = JSON.parse(aMatch.theMessage);
                aMatch.lastMsgIsAudio = true;
              } catch (error) {
                console.log("Text message starting with { and ending with }. Error Trying to parse text as JSON");
              }
            }
  
          }
  
          if(aMatch.newBadge) {
            newOnes++;
          }
          
          var d = new Date(aMatch.relevantDate * 1000);
          aMatch.relevantTime = this.userService.formatDate(d, this.userData) + ' ' + 
                                this.userService.formatTime(d);
  
          newSouls.push( aMatch );
        }
        this.souls = newSouls;
        
        // Parse theMessage if we have an audio message
        this.souls = this.souls.map((item: any) => {
          let parsed = {};
          if (item.theMessage && typeof item.theMessage === 'string') {
            try {
              parsed = JSON.parse(JSON.parse(item.theMessage)); // Duplo parse
            } catch {
              try {
                parsed = JSON.parse(item.theMessage); // Fallback para parse simples
              } catch {
                parsed = {}; // Fallback para objeto vazio
              }
            }
          }

          return { ...item, parsedMessage: parsed };
        });

        Preferences.set({key:'MATCHES', value: JSON.stringify(this.souls)}).then((val)=>{
          console.log('matches saved to DB');
        })
        this.matchSubject.next(newOnes);
  
      }
  
    } catch (error) {
      console.log('Error on loadScreen() on match-service:')
      console.log(error)
      console.error(error);
    }
  }

  

  useURLforImage(aSoul: any){
    let picnum : number;
    for(picnum=0; picnum<9; picnum++) {
      let aPic: string = "picture" + picnum;
      if(aSoul[aPic] != null) {
       //console.log('match-service.loadMatches Contains ' + aPic);
       //console.log('aSoul[aPic].$oid: ' + aSoul[aPic].$oid);
       aSoul.firstPic = this.userService.getImageURL(aSoul[aPic].$oid); //this.soulService.getBaseURL() + '/soul/image/' + aSoul[aPic].$oid;
       break;
     }
    }

  }

  markAsRead(soulToChat : any){
    console.log('markAsRead called'+ JSON.stringify(soulToChat));
    console.log(!soulToChat.newBadge)
    if(!soulToChat.newBadge){
      return;// No need
    }
    this.eventService.publish('updateNewCount', 1);
    var theObs : Observable<any>;
    theObs = this.userService.markRead(this.userData?._id.$oid, 
                                        soulToChat._id.$oid, 
                                        soulToChat.lastMessage!=null);

    theObs.subscribe(data => {
      console.log('markAsRead subscribe entered');
      console.log('data = ' + JSON.stringify(data));
      soulToChat.newBadge = false;
      this.matchSubject.next(-1);
    },
    err => {
      console.log('Error: ' + JSON.stringify(err));
    })
  
  }
}
